import { Component, Input, OnChanges } from '@angular/core';
import { ChartDonutComponent, ChartDonutConfig } from './chart-donut.component';

export interface ChartDonutGroupConfig {
  groupField: string;
  chart: ChartDonutConfig;
}

interface ChartDonutGroupItem {
  key: string;
  data: any[];
}

@Component({
  selector: 'app-chart-donut-group',
  standalone: true,
  template: `
    <div class="grid pt-2 pb-2">
      @for (group of groups; track group.key) {
        <div class="col-12 md:col-6 mb-2">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div class="dash-title">{{ group.key }}</div>
            </div>
            <div class="dash-body">
              <app-chart-donut [config]="config.chart" [data]="group.data"/>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  imports: [ChartDonutComponent]
})
export class ChartDonutGroupComponent implements OnChanges {

  @Input() config!: ChartDonutGroupConfig;
  @Input() data: any[] = [];

  groups: ChartDonutGroupItem[] = [];

  ngOnChanges(): void {
    if (!this.config || !this.data?.length) return;

    const grouped = new Map<string, any[]>();
    this.data.forEach(row => {
      const key = row[this.config.groupField];
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key)!.push(row);
    });
    this.groups = [...grouped.entries()].map(([key, data]) => ({ key, data }));
  }
}
